var modules_997b7aad = {"logo":"Logo_module_logo__a5ffdbf0"};
import "../../../assets/esm/components/Logo/src/Logo~CyCiiFoq.css";

export { modules_997b7aad as default };
//# sourceMappingURL=Logo.module.less.js.map
